import { render, staticRenderFns } from "./ModalImportRequisitionDetail.vue?vue&type=template&id=67e6bb2e&lang=pug&"
import script from "./ModalImportRequisitionDetail.vue?vue&type=script&lang=js&"
export * from "./ModalImportRequisitionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ModalImportRequisitionDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports